// API Configuration
// Change this single line to update the endpoint for the entire application
export const API_BASE_URL = process.env.API_URL || "https://kozlebackend.zenit.poznan.pl/api/v1";
